jQuery(function($) {

	// Anchor links
	$('a[href^=\\#]').on('click', function(e) {
		e.preventDefault();

		var $elem = $($.attr(this, 'href'));
		if ( $elem.length > 0 ) {
			$('html, body').animate({
				scrollTop: $elem.offset().top - $('.main-header').outerHeight() - 30
			}, 700);
		}
	});

	// Init modules
	RBHelper.initAnimations();
	RBHelper.initSiteNotice();
	RBHelper.initTabbedServices();
	RBHelper.initFAQAccordion();
	RBHelper.initSearchbox();
	RBHelper.initStatsAnimation();
	RBHelper.initFacetWPAddons();
	RBHelper.initGuideModals();
	RBHelper.initSidebarJumpMenu();
	RBHelper.initCallToAction();

	// Init swiper modules
	RBHelper.initTestimonialSwiper();
	RBHelper.initHomeTeamSwiper();
	RBHelper.initFWPageTeamSwiper();
	RBHelper.initPageTeamSwiper();
	RBHelper.initFWReviewsSwiper();
	RBHelper.initReviewsSwiper();
	RBHelper.initPageArticlesSwiper();
	RBHelper.initPageSSSwiper();
	RBHelper.initGuidesSwiper();
	RBHelper.initProfileLogosSwiper();
	RBHelper.initLogoSwiper();

	// Initialize menus
	RBHelper.initOffcanvasMenu();
	RBHelper.initFlymenu();

	RBHelper.initYouTubePlayerSetup();

	// Initialize headroom
	(new Headroom(document.querySelector('.main-header'))).init();

});

let RBHelper = (function(window, document, $, undefined) {
	const getSwiperDefaults = ($wrapper) => ({
		direction: 'horizontal',
		disableOnInteraction: false,
		pauseOnMouseEnter: false,
		pagination: {
			el: $wrapper.find('.jsSliderPagination')[0],
			type: "fraction"
		},
		navigation: {
			nextEl: $wrapper.find('.jsSliderNavigationNext')[0],
			prevEl: $wrapper.find('.jsSliderNavigationPrev')[0],
		},
		watchOverflow: true,
		shortSwipes: false
	});

	const getSwiperPagination = ($el) => ({
		el: $el,
		clickable: true,
		renderBullet: function(_index, className) {
			return '<span class="' + className + '"></span>';
		}
	});

	const initTestimonialSwiper = () => {
		$('.jsTestimonialSlider').each(function() {
			let $wrapper = $(this);
			let $slider = $wrapper.find('.swiper')[0];

			let swiper = new Swiper($slider, {
				...getSwiperDefaults($wrapper),
				loop: true,
				autoHeight: true,
				slidesPerView: 1,
				spaceBetween: 0,
				effect: 'fade',
				fadeEffect: {
					crossFade: true
				},
			});
		});
	}

	const initHomeTeamSwiper = () => {
		$('.jsHomeTeamSlider').each(function() {
			let $wrapper = $(this);
			let $slider = $wrapper.find('.swiper')[0];

			let swiper = new Swiper($slider, {
				...getSwiperDefaults($wrapper),
				loop: true,
				slidesPerView: 1,
				spaceBetween: 20,
				breakpoints: {
					744: {
						slidesPerView: 2
					}
				},
			});

			$wrapper.find('.jsSliderNavigationNextOutside').on( 'click', function() {
				swiper.slideNext();
			} );

			$wrapper.find('.jsSliderNavigationPrevOutside').on( 'click', function() {
				swiper.slidePrev();
			} );
		});
	}

	const initLogoSwiper = () => {
		$(".js-logo-carousel").each(function () {
			const sliderContainer = $(this);
			const sliderEl = $(".swiper", sliderContainer)[0];

			const swiper = new Swiper(sliderEl, {
				direction: "horizontal",
				slidesPerView: 2,
				centerInsufficientSlides: true,
				spaceBetween: 20,

				breakpoints: {
					460: {
						slidesPerView: 'auto',
						spaceBetween: 40,
					},
					500: {
						slidesPerView: 'auto',
						spaceBetween: 60,
					},
					744: {
						slidesPerView: 'auto',
						spaceBetween: 80,
					},
					1400: {
						slidesPerView: 5,
						spaceBetween: 60,
					}
				},

				navigation: {
					prevEl: sliderContainer.find('.js-carousel-nav-prev')[0],
					nextEl: sliderContainer.find('.js-carousel-nav-next')[0],
				},
			});
		});
	}

	const initFWPageTeamSwiper = () => {
		$('.jsFWPageTeamSlider').each(function() {
			let $wrapper = $(this);
			let $slider = $wrapper.find('.swiper')[0];

			let swiper = new Swiper($slider, {
				...getSwiperDefaults($wrapper),
				loop: false,
				slidesPerView: 1,
				spaceBetween: 20,
				breakpoints: {
					744: {
						slidesPerView: 2,
						spaceBetween: 20
					},
					1200: {
						slidesPerView: 3,
						spaceBetween: 40
					}
				},
			});
		});
	}

	const initPageTeamSwiper = () => {
		$('.jsPageTeamSlider').each(function() {
			let $wrapper = $(this);
			let $slider = $wrapper.find('.swiper')[0];

			let swiper = new Swiper($slider, {
				...getSwiperDefaults($wrapper),
				loop: false,
				slidesPerView: 1,
				spaceBetween: 20,
				breakpoints: {
					744: {
						slidesPerView: 2,
						spaceBetween: 20
					},
					1200: {
						slidesPerView: 3,
						spaceBetween: 10
					}
				},
			});
		});
	}

	const initFWReviewsSwiper = () => {
		$('.jsFWReviewsSlider').each(function() {
			let $wrapper = $(this);
			let $slider = $wrapper.find('.swiper')[0];

			let swiper = new Swiper($slider, {
				...getSwiperDefaults($wrapper),
				loop: false,
				autoHeight: true,
				slidesPerView: 1,
				spaceBetween: 20,
				breakpoints: {
					744: {
						slidesPerView: 2,
						spaceBetween: 20
					},
					1200: {
						slidesPerView: 3,
						spaceBetween: 40
					}
				},
			});
		});
	}

	const initReviewsSwiper = () => {
		$('.jsReviewsSlider').each(function() {
			let $wrapper = $(this);
			let $slider = $wrapper.find('.swiper')[0];

			let swiper = new Swiper($slider, {
				...getSwiperDefaults($wrapper),
				loop: false,
				autoHeight: true,
				slidesPerView: 1,
				spaceBetween: 20,
				breakpoints: {
					744: {
						slidesPerView: 2,
						spaceBetween: 20
					},
					1200: {
						slidesPerView: 2,
						spaceBetween: 40
					}
				},
			});
		});
	}

	const initPageSSSwiper = () => {
		$('.jsPageSSSlider').each(function() {
			let $wrapper = $(this);
			let $slider = $wrapper.find('.swiper')[0];
			let $pagination = $wrapper.find('.jsPageSSSliderPagination')[0];

			let swiper = new Swiper($slider, {
				...getSwiperDefaults($wrapper),
				loop: false,
				slidesPerView: 1,
				spaceBetween: 20,
				breakpoints: {
					744: {
						slidesPerView: 2,
						spaceBetween: 20
					},
					1200: {
						slidesPerView: 3,
						spaceBetween: 40
					}
				},
			});
		});
	}

	const initPageArticlesSwiper = () => {
		$('.jsPageArticlesSlider').each(function() {
			let $wrapper = $(this);
			let $slider = $wrapper.find('.swiper')[0];

			let swiper = new Swiper($slider, {
				...getSwiperDefaults($wrapper),
				slidesPerView: 1,
				spaceBetween: 20,
				breakpoints: {
					744: {
						slidesPerView: 2
					},
					1200: {
						slidesPerView: 3
					}
				},
			});
		});
	}

	const initProfileLogosSwiper = () => {
		$('.jsProfilelogosSlider').each(function() {
			let $wrapper = $(this);
			let $slider = $wrapper.find('.swiper')[0];

			let swiper = new Swiper($slider, {
				...getSwiperDefaults($wrapper),
				loop: false,
				freeMode: {
					enabled: true,
					sticky: true
				},
				slidesPerView: 2,
				spaceBetween: 20,
				breakpoints: {
					744: {
						slidesPerView: 3
					},
					1200: {
						slidesPerView: 4,
						spaceBetween: 40
					}
				},
			});
		});
	}

	const initGuidesSwiper = () => {
		$('.jsGuidesBoxSlider').each(function() {
			let $wrapper = $(this);
			let $slider = $wrapper.find('.swiper')[0];
			let $pagination = $wrapper.find('.jsGuidesBoxSliderPagination')[0];

			let swiper = new Swiper($slider, {
				loop: false,
				slidesPerView: 1,
				spaceBetween: 0,
				effect: 'fade',
				allowTouchMove: false,
				fadeEffect: {
					crossFade: true
				},
				pagination: {
					el: $wrapper.find('.jsSliderPagination')[0],
					type: "fraction"
				},
				navigation: {
					nextEl: $wrapper.find('.jsSliderNavigationNext')[0],
					prevEl: $wrapper.find('.jsSliderNavigationPrev')[0],
				},
				watchOverflow: true,
				preventClicks: false,
				preventClicksPropagation: false,
				shortSwipes: false,
			});

			swiper.on('slideChange', function() {
				const $leaflet = $wrapper.parent().closest('.jsGuidesBox').find('.jsChangeFrontCover');
				const slideIndex = swiper.activeIndex;

				$leaflet.find('.guide-leaflet-main-img').addClass('hidden');
				console.log( slideIndex );
				$leaflet.find(`.guide-leaflet-main-img--${slideIndex}`).removeClass('hidden');
			})
		})
	}

	const initAnimations = () => {
		var $waypoint = $( '.js-waypoint' );
		var waypointVisible = 'is-visible';

		if ( window.matchMedia( '(min-width: 768px)' ).matches ) {
			$waypoint.each( function() {
				$( this ).waypoint( {
					handler: function() {
						$( this.element ).addClass( waypointVisible );
						this.destroy();
					},
					offset: '90%'
				} );
			} );
		} else {
			$waypoint.addClass( waypointVisible );
		}
	}

	const initSiteNotice = () => {
		const $notice = $( '.js-site-notice' );
		const $close = $( '.js-site-notice-close' );

		$( window ).load( function() {

			if ( $notice.length ) {
				// Hide notice and set cookie to hide it for 1 day
				$close.on( 'click', function(e) {
					e.preventDefault();

					$notice.hide();
					Cookies.set( 'notice-closed', 'true', { expires: 1 } );
				} );
			}
		} );
	}

	const initTabbedServices = () => {
		$('.jsTabbedServicesNav a').on('click', function() {
			const tabId = $(this).data('tab');

			// Hightlight nav item
			$(this).parent().find('a').removeClass('is-active');
			$(this).addClass('is-active');

			// Toggle tab
			$('.jsTabbedServicesTab').removeClass('is-active');
			$(`.jsTabbedServicesTab[data-tab-id="${tabId}"]`).addClass('is-active');

			// Toggle mobile accordion row heads
			$('.jsTabbedServiceFAQRowHead').removeClass('is-active');
			$(`.jsTabbedServiceFAQRowHead[data-tab="${tabId}"]`).addClass('is-active');
		});

		$('.jsTabbedServiceFAQRowHead').on('click', function(e) {
			e.preventDefault();

			const $head = $(this);
			const $wrapper = $head.parent().closest('.jsTabbedServiceFAQWrapper');
			const $content = $head.next();
			const tabId = $content.data('tab-id');

			if ( $head.hasClass('is-active') ) {
				// return;

				$wrapper.find('.jsTabbedServicesNav a').removeClass('is-active');
				$head.removeClass('is-active');

				$wrapper
						.find('.jsTabbedServiceFAQRowContent')
						.each(function(index) {
							$(this).slideUp(400, function() {
								$(this).removeClass('is-active');
								this.style.removeProperty('display');
							});
						});
			} else {
				$wrapper.find('.jsTabbedServicesNav a').removeClass('is-active');
				$wrapper.find(`.jsTabbedServicesNav a[data-tab="${tabId}"]`).addClass('is-active');

				$wrapper.find('.jsTabbedServiceFAQRowHead').removeClass('is-active');
				$head.addClass('is-active');

				const len = $wrapper.find('.jsTabbedServiceFAQRowContent').length;
				$wrapper
						.find('.jsTabbedServiceFAQRowContent')
						.each(function(index) {
							$(this).slideUp(400, function() {
								$(this).removeClass('is-active');
								this.style.removeProperty('display');

								if ( index === (len - 1) ) {
									$content.slideDown(400, function() {
										$(this).addClass('is-active');
										this.style.removeProperty('display');

										$('html, body').animate({
											scrollTop: $head.offset().top - $('.main-header').outerHeight()
										}, 700);
									});
								}
							});
						});
			}
		});
	}

	const initFAQAccordion = () => {
		$('.jsFAQRowHead').on('click', function(e) {
			e.preventDefault();

			$(this).parent().closest('.jsFAQRow').toggleClass('is-active');
			$(this).parent().closest('.jsFAQRow').find('.jsFAQRowContent').slideToggle();
		});
	}

	const initOffcanvasMenu = () => {
		$('.jsOffcanvasMenuToggler').on('click', function(e) {
			e.preventDefault();

			$('.jsOffcanvasMenuNavSubmenu').removeClass('is-active');
			$('.jsOffcanvasMenuNavLinks').removeClass('is-active');
			$('.jsOffcanvasMenuNavBackbtn').removeClass('is-active');

			if ( $(this).hasClass('is-active') ) {
				$(this).removeClass('is-active');
				$('.jsOffcanvasMenu').removeClass('is-active');
				$(document.body).removeClass('has-open-menu');
			} else {
				$(this).addClass('is-active');
				$('.jsOffcanvasMenu').addClass('is-active');
				$(document.body).addClass('has-open-menu');
			}
		});

		$(window).on('resize', function() {
			if ( window.matchMedia('(min-width: 1330px)').matches ) {
				$('.jsOffcanvasMenuToggler').removeClass('is-active');
				$('.jsOffcanvasMenu').removeClass('is-active');
				$('.jsOffcanvasMenuNavSubmenu').removeClass('is-active');
				$('.jsOffcanvasMenuNavLinks').removeClass('is-active');
				$('.jsOffcanvasMenuNavBackbtn').removeClass('is-active');
				$(document.body).removeClass('has-open-menu');
			}
		});

		$('.jsOffcanvasMenuNav .is-clickable').on('click', function(e) {
			e.preventDefault();

			var $submenu = $(this).parent().find('.jsOffcanvasMenuNavSubmenu');
			var $links = $(this).parent().find('.jsOffcanvasMenuNavLinks');

			if ( !!$submenu.length ) {
				$submenu.addClass('is-active');
				$('.jsOffcanvasMenuNavBackbtn').addClass('is-active');
				return;
			}

			if ( !!$links.length ) {
				$links.addClass('is-active');
				$('.jsOffcanvasMenuNavBackbtn').addClass('is-active');
				return;
			}
		});

		$('.jsOffcanvasMenuNavBackbtn').on('click', function(e) {
			e.preventDefault();

			var $submenu = $('.jsOffcanvasMenuNavSubmenu.is-active');
			var $links = $('.jsOffcanvasMenuNavLinks.is-active');

			if ( !!$links.length ) {
				$links.removeClass('is-active');
				return;
			}

			if ( !!$submenu.length ) {
				$submenu.removeClass('is-active');
				$('.jsOffcanvasMenuNavBackbtn').removeClass('is-active');
				return;
			}
		});
	}

	const initFlymenu = () => {
		$('[data-flymenu-trigger]').on('mouseenter', function() {
			const id = $(this).attr('data-flymenu-trigger');
			const $wrapper = $(this).parent().closest('[data-flymenu-wrapper]');

			$wrapper.find('[data-flymenu-trigger]').removeClass('is-active');
			$(this).addClass('is-active');

			$wrapper.find('[data-flymenu-target]').removeClass('is-active');
			$wrapper.find(`[data-flymenu-target="${id}"]`).addClass('is-active');

			$wrapper.find('[data-flymenu-target]').find('.guide-leaflet').removeClass('is-animated');
			$wrapper.find(`[data-flymenu-target="${id}"]`).find('.guide-leaflet').addClass('is-animated');
		});

		$('.jsFlymenuTrigger').on('mouseenter', function() {
			$('.jsFlymenuTrigger').removeClass('is-active');
			$(this).addClass('is-active');

			$('.jsFlymenu').removeClass('is-active');
			$(this).parent().find('.jsFlymenu').addClass('is-active');

			$('.jsFlymenu').find('.guide-leaflet').removeClass('is-animated');
			$('.jsFlymenu').find('[data-flymenu-target].is-active').find('.guide-leaflet').addClass('is-animated');
		});

		$('.jsFlymenu').on('mouseleave', function() {
			$('.jsFlymenuTrigger').removeClass('is-active');
			$('.jsFlymenu').removeClass('is-active');
			$('.jsFlymenu').find('.guide-leaflet').removeClass('is-animated');
		})
	}

	const initSearchbox = () => {
		$('.jsSearchToggler').on('click', function() {
			$('.jsMainSearch').toggleClass('is-active');
		});

		$('.jsHelpSearchSubmit').on('click', function() {
			$(this).parent().find('.promagnifier').click();
		})
	}

	const initStatsAnimation = () => {
		$('[data-stat]').each(function () {

			var done = false;
			var $this = $(this);
			var int = Number.isInteger(Number($this.text()));

			$this.waypoint(function(direction) {

				if ( !done ) {
					done = true;
					$this.prop('Counter', 0).animate({ Counter: $this.text() }, {
						duration: 2000,
						easing: 'swing',
						step: function (now) {
							$this.text(int ? Math.ceil(now) : this.Counter.toFixed(1));
						}
					});
				}

			}, { offset: '75%' });

		});
	}

	const initFacetWPAddons = () => {
		const placeholderFix = function() {
			$(this).toggleClass('has-value', !!$(this).val());
		}

		const pagerFix = () => {
			const $pager = $('.facetwp-pager');

			if ( !$pager.length )
				return;

			$pager.parent().removeClass('hidden');
			if ( !$pager.children().length ) {
				$pager.parent().addClass('hidden');
				return;
			}

			if ( !$pager.find('.facetwp-page.prev').length ) {
				$pager.prepend('<a class="facetwp-page prev is-disabled">Previous</a>');
				return;
			}

			if ( !$pager.find('.facetwp-page.next').length ) {
				$pager.append('<a class="facetwp-page next is-disabled">Next</a>');
				return;
			}
		}

		$(document).on('change', 'select.facetwp-dropdown', placeholderFix);
		$(document).on('facetwp-refresh', function() {
			if (FWP.soft_refresh == true) {
				FWP.enable_scroll = true;
			} else {
				FWP.enable_scroll = false;
			}
		});

		$(document).on('facetwp-loaded', function() {
			$('select.facetwp-dropdown').each(placeholderFix);
			pagerFix();

			if (FWP.enable_scroll == true) {
				const $items = $( '.archive-page' );

				$('html, body').animate({
					scrollTop: $items.offset().top - 120
				  }, 500);
			}
		});
	}

	const initGuideModals = () => {
		$('[data-open-guide-modal]').on('click', function() {
			const guideID = $(this).attr('data-open-guide-modal');
			$(`[data-guide-modal="${guideID}"]`).addClass('is-active');
			$('body').addClass('overflow-hidden');

			setTimeout(() => {
				$(`[data-guide-modal="${guideID}"]`).find('.guide-leaflet').addClass('is-animated');
			}, 400);
		});

		$('.jsGuideModalClosebtn').on('click', function(e) {
			e.preventDefault();
			$(this).parent().closest('.jsGuideModal').removeClass('is-active');
			$(this).parent().closest('.jsGuideModal').find('.guide-leaflet').removeClass('is-animated');
			$('body').removeClass('overflow-hidden');
		});

		$('[data-guide-animate]').each(function() {
			let $this = $(this);
			$this.waypoint(function(direction) {
				$this.addClass('is-animated');
			}, { offset: '75%' });
		});
	}

	const initSidebarJumpMenu = () => {
		if ( !!$('.jsSidebarJumpMenu').length && !!$('.jsStickyJumpMenu').length ) {

			function highlightMenuitem( id ) {
				if ( $(`.jsSidebarJumpMenuLink[href="#${id}"]`).length > 0 ) {
					$('.jsSidebarJumpMenuLink').removeClass('is-active');
					$(`.jsSidebarJumpMenuLink[href="#${id}"]`).addClass('is-active');
					$('.jsStickyJumpMenuLink').removeClass('is-active');
					$(`.jsStickyJumpMenuLink[href="#${id}"]`).addClass('is-active');
					$('.jsStickyJumpMenuCaption').text(
						$(`.jsSidebarJumpMenuLink[href="#${id}"]`).text()
					);
				}
			}

			$('.section-anchorpoint').each(function() {
				$(this).waypoint({
					handler: function ( dir ) {
						if ( dir === 'down' ) {
							highlightMenuitem( this.element.id );
						}
					}, offset: 90
				});
				$(this).waypoint({
					handler: function ( dir ) {
						if ( dir === 'up' ) {
							highlightMenuitem( this.element.id );
						}
					}, offset: '-50%'
				});
			});

			$('.jsStickyJumpMenuAction').on('click', function() {
				$(this).toggleClass('is-active');
				$(this)
					.parent()
					.closest('.jsStickyJumpMenu')
					.find('.jsStickyJumpMenuList')
					.slideToggle();
			});

			$('.jsStickyJumpMenuLink').on('click', function() {
				$(this)
					.parent()
					.closest('.jsStickyJumpMenu')
					.find('.jsStickyJumpMenuAction')
					.removeClass('is-active');
				$(this)
					.parent()
					.closest('.jsStickyJumpMenu')
					.find('.jsStickyJumpMenuList')
					.slideUp();
			});

		}
	}

	const initCallToAction = () => {
		if (document.querySelector('.js-floating-cta')) {
			const ctaButton = document.querySelector('.js-floating-cta');
			const cta = document.querySelector('.js-floating-cta-modal');
			const ctaClose = cta.querySelector('.js-floating-cta-close');

			const ctaActiveClass = 'floating-cta-modal--open';

			ctaButton.addEventListener('click', function() {
				cta.classList.toggle(ctaActiveClass);
			});

			ctaClose.addEventListener('click', function() {
				cta.classList.remove(ctaActiveClass);
			});
		}
	}

	const initYouTubePlayerSetup = () => {
		const isScriptAlready = document.getElementById('youtube-iframe-api');

		if ( isScriptAlready ) {
			return;
		}

		var tag = document.createElement('script');
		tag.id = "youtube-iframe-api";
		tag.src = "https://www.youtube.com/iframe_api";
		var rb_script = document.getElementById('main-js');
		rb_script.insertAdjacentElement('afterend', tag);
	}

	return {
		initTestimonialSwiper,
		initHomeTeamSwiper,
		initFWPageTeamSwiper,
		initPageTeamSwiper,
		initFWReviewsSwiper,
		initReviewsSwiper,
		initPageSSSwiper,
		initPageArticlesSwiper,
		initProfileLogosSwiper,
		initGuidesSwiper,
		initAnimations,
		initSiteNotice,
		initTabbedServices,
		initFAQAccordion,
		initOffcanvasMenu,
		initFlymenu,
		initSearchbox,
		initStatsAnimation,
		initFacetWPAddons,
		initGuideModals,
		initSidebarJumpMenu,
		initCallToAction,
		initYouTubePlayerSetup,
		initLogoSwiper,
	}
})(window, document, jQuery);

function onYouTubeIframeAPIReady() {
	let players = document.querySelectorAll('.js-muted-video');

	players.forEach(playerLoopItem => {
		const video_id = playerLoopItem.dataset.video;
		const unmuteBtn = playerLoopItem.nextElementSibling;

		const playerOptions = {
			videoId: video_id,
			playerVars: {
				controls: 1,
				cc_load_policy: 1,
				hl: 'en',
				rel: 0,
				playsinline: 1,
				modestbranding: 0,
				autoplay: 1,
				mute: 1,
			}
		};

		let player = new YT.Player(playerLoopItem, playerOptions);

		unmuteBtn.addEventListener('click', function() {
			player.unMute();
			unmuteBtn.classList.add('is-hidden');
		});
	});
}
